
const componentSearch = require('../component-search/component-search.config.js');
const componentHeaderToggle = require('../component-header-toggle/component-header-toggle.config.js');

module.exports = {
	title: 'Header Bar',
	notes: '',
	context: {
		componentSearch: componentSearch.context,
		componentHeaderToggle: componentHeaderToggle.context
	}
};
